// // // src/utils/pdfGenerator.js - Updated to use new verification structure

// // import { Platform } from 'react-native';
// // import * as FileSystem from 'expo-file-system';
// // import * as Sharing from 'expo-sharing';

// // const generatePDFContent = (data) => {
// //   const {
// //     verification,
// //     documentStatus,
// //     submissionDate
// //   } = data;

// //   const formatDate = (date) => {
// //     if (!date) return 'Non spécifié';
// //     try {
// //       return new Date(date).toLocaleDateString('fr-FR');
// //     } catch {
// //       return 'Non spécifié';
// //     }
// //   };

// //   const formatValue = (value) => {
// //     if (value === null || value === undefined || value === '') return 'Non spécifié';
// //     if (typeof value === 'boolean') return value ? 'Oui' : 'Non';
// //     return String(value);
// //   };

// //   const getDocumentStatusEmoji = (status) => {
// //     return status === 'provided' ? '✅' : status === 'skipped' ? '⏭️' : '❌';
// //   };

// //   let pdfText = [];
  
// //   // ========== HEADER ==========
// //   pdfText.push('='.repeat(60));
// //   pdfText.push('               RÉCAPITULATIF DE LA VÉRIFICATION');
// //   pdfText.push('='.repeat(60));
// //   pdfText.push(`Date de génération: ${formatDate(submissionDate)}`);
// //   pdfText.push(`ID de vérification: ${verification?.verificationId || 'Non spécifié'}`);
// //   pdfText.push(`Rôle: ${verification?.actorRole === 'OWNER' ? 'Propriétaire' : 'Chauffeur'}`);
// //   pdfText.push('');
  
// //   // ========== VEHICLE INFORMATION ==========
// //   pdfText.push('1. INFORMATIONS DU VÉHICULE');
// //   pdfText.push('-'.repeat(40));
  
// //   const vehicle = verification?.vehicle || {};
// //   const vehicleAdmin = verification?.vehicleAdmin || {};
  
// //   pdfText.push(`Immatriculation: ${formatValue(vehicle.registrationNumber || verification?.numeimma)}`);
// //   pdfText.push(`Marque: ${formatValue(vehicle.brand)}`);
// //   pdfText.push(`Modèle: ${formatValue(vehicle.model)}`);
// //   pdfText.push(`Numéro de chassis: ${formatValue(vehicle.chassisNumber)}`);
// //   pdfText.push(`Année de 1ère immatriculation: ${formatValue(vehicle.firstRegistrationYear)}`);
// //   pdfText.push(`Nombre de places: ${formatValue(vehicle.seats)}`);
// //   pdfText.push(`Municipalité: ${formatValue(vehicle.municipality || vehicleAdmin.municipality)}`);
// //   pdfText.push(`Numéro de carte bleue: ${formatValue(vehicle.blueCardNumber || vehicleAdmin.blueCardNumber)}`);
// //   pdfText.push(`Date de carte bleue: ${formatValue(vehicle.blueCardIssueDate || vehicleAdmin.blueCardIssueDate)}`);
// //   pdfText.push(`Numéro de macaron: ${formatValue(vehicle.macaronNumber || vehicleAdmin.macaronNumber)}`);
// //   pdfText.push(`Numéro de portière: ${formatValue(vehicle.doorNumber)}`);
// //   pdfText.push(`Vignette d\'assurance valide: ${formatValue(vehicle.insuranceStickerValid)}`);
// //   pdfText.push('');
  
// //   // ========== TECHNICAL INSPECTION ==========
// //   if (vehicleAdmin) {
// //     pdfText.push('CONTROLE TECHNIQUE');
// //     pdfText.push('-'.repeat(40));
// //     pdfText.push(`Valide: ${formatValue(vehicleAdmin.technicalInspectionValid)}`);
// //     pdfText.push(`Date du contrôle: ${formatValue(vehicleAdmin.technicalInspectionDate)}`);
// //     pdfText.push('');
// //   }
  
// //   // ========== OWNER INFORMATION ==========
// //   pdfText.push('2. INFORMATIONS DU PROPRIÉTAIRE');
// //   pdfText.push('-'.repeat(40));
  
// //   const owner = verification?.owner || {};
  
// //   pdfText.push(`Type: ${owner.type === 'PHYSIQUE' ? 'Personne physique' : 'Personne morale'}`);
  
// //   if (owner.type === 'PHYSIQUE') {
// //     pdfText.push(`Nom complet: ${formatValue(owner.fullName || `${owner.firstName || ''} ${owner.lastName || ''}`)}`);
// //     pdfText.push(`Prénom: ${formatValue(owner.firstName)}`);
// //     pdfText.push(`Nom: ${formatValue(owner.lastName)}`);
// //     pdfText.push(`Sexe: ${formatValue(owner.gender)}`);
// //   } else {
// //     pdfText.push(`Nom de l'entreprise: ${formatValue(owner.organizationName)}`);
// //   }
  
// //   pdfText.push(`Téléphone: ${formatValue(owner.phone)}`);
// //   pdfText.push(`Email: ${formatValue(owner.email)}`);
// //   pdfText.push(`Numéro CIN: ${formatValue(owner.cinNumber)}`);
// //   pdfText.push(`Numéro contribuable: ${formatValue(owner.taxpayerNumber)}`);
// //   pdfText.push(`Syndicat: ${formatValue(owner.ownerSyndicate)}`);
// //   pdfText.push(`Numéro de licence catégorie: ${formatValue(owner.categoryLicenseNumber || vehicleAdmin.ownerCatLicenseNumber)}`);
// //   pdfText.push(`Date de licence: ${formatValue(owner.categoryLicenseIssueDate || vehicleAdmin.ownerCatLicenseIssueDate)}`);
// //   pdfText.push(`Nombre de taxis exploités: ${formatValue(owner.taxisOperated || vehicleAdmin.taxisOperated)}`);
// //   pdfText.push(`A procuration: ${owner.hasProcuration ? 'Oui' : owner.skipProcuration ? 'Ignoré' : 'Non'}`);
// //   pdfText.push('');
  
// //   // ========== DRIVER INFORMATION ==========
// //   pdfText.push('3. INFORMATIONS DES CHAUFFEURS');
// //   pdfText.push('-'.repeat(40));
  
// //   const drivers = verification?.drivers || [];
// //   const driverObj = verification?.driver || {};
// //   const driverDocuments = verification?.driverDocuments || {};
  
// //   // If this is driver workflow (single driver)
// //   if (verification?.actorRole === 'DRIVER' && driverObj.personId) {
// //     pdfText.push('\nChauffeur principal:');
// //     pdfText.push(`  ID Personne: ${formatValue(driverObj.personId)}`);
// //     pdfText.push(`  Nom complet: ${formatValue(driverObj.fullName || `${driverObj.firstName || ''} ${driverObj.lastName || ''}`)}`);
// //     pdfText.push(`  Téléphone: ${formatValue(driverObj.phone)}`);
// //     pdfText.push(`  Email: ${formatValue(driverObj.email)}`);
// //     pdfText.push(`  Date de naissance: ${formatValue(driverObj.birthDate)}`);
// //     pdfText.push(`  Sexe: ${formatValue(driverObj.gender)}`);
// //     pdfText.push(`  Numéro CIN: ${formatValue(driverObj.cinNumber)}`);
// //     pdfText.push(`  Numéro contribuable: ${formatValue(driverObj.taxpayerNumber)}`);
// //     pdfText.push(`  Numéro de permis: ${formatValue(driverObj.licenseNumber)}`);
// //     pdfText.push(`  Catégorie de permis: ${formatValue(driverObj.licenseCategory)}`);
// //     pdfText.push(`  Syndicat: ${formatValue(driverObj.driverSyndicate)}`);
// //     pdfText.push(`  Numéro de capacité: ${formatValue(driverObj.capacityNumber)}`);
// //     pdfText.push(`  A document de capacité: ${driverObj.hasCapacityDoc ? 'Oui' : 'Non'}`);
// //     pdfText.push(`  A badge de sécurité: ${driverObj.secureBadge === true ? 'Oui' : driverObj.secureBadge === false ? 'Non' : 'Non spécifié'}`);
    
// //     // Documents for this driver
// //     const docs = driverDocuments[driverObj.personId] || {};
// //     pdfText.push(`  Photo fournie: ${docs.photo ? '✅' : '❌'}`);
// //     pdfText.push(`  Permis fourni: ${docs.license ? '✅' : '❌'}`);
// //     pdfText.push(`  Carte d'identité fournie: ${docs.idCard ? '✅' : '❌'}`);
// //     pdfText.push(`  Document de capacité fourni: ${docs.capacity ? '✅' : '❌'}`);
    
// //   } 
// //   // If this is owner workflow (multiple drivers)
// //   else if (drivers.length > 0) {
// //     drivers.forEach((driver, index) => {
// //       pdfText.push(`\nChauffeur ${index + 1}:`);
// //       pdfText.push(`  ID Personne: ${formatValue(driver.personId)}`);
// //       pdfText.push(`  Nom complet: ${formatValue(driver.name)}`);
// //       pdfText.push(`  Téléphone: ${formatValue(driver.phone)}`);
// //       pdfText.push(`  Email: ${formatValue(driver.email)}`);
// //       pdfText.push(`  Date de naissance: ${formatValue(driver.birthDate)}`);
// //       pdfText.push(`  Sexe: ${formatValue(driver.gender)}`);
// //       pdfText.push(`  Numéro CIN: ${formatValue(driver.cinNumber)}`);
// //       pdfText.push(`  Numéro contribuable: ${formatValue(driver.taxpayerNumber)}`);
// //       pdfText.push(`  Numéro de permis: ${formatValue(driver.licenseNumber)}`);
// //       pdfText.push(`  Catégorie de permis: ${formatValue(driver.licenseCategory)}`);
// //       pdfText.push(`  Syndicat: ${formatValue(driver.driverSyndicate)}`);
// //       pdfText.push(`  Numéro de capacité: ${formatValue(driver.capacityNumber)}`);
// //       pdfText.push(`  A document de capacité: ${driver.hasCapacityDoc ? 'Oui' : 'Non'}`);
// //       pdfText.push(`  A badge de sécurité: ${driver.secureBadge === true ? 'Oui' : driver.secureBadge === false ? 'Non' : 'Non spécifié'}`);
      
// //       // Documents for this driver
// //       const docs = driverDocuments[driver.personId] || {};
// //       pdfText.push(`  Photo fournie: ${driver.hasDriverPhoto ? '✅' : '❌'}`);
// //       pdfText.push(`  Permis fourni: ${driver.hasDriverLicense ? '✅' : '❌'}`);
// //       pdfText.push(`  Carte d'identité fournie: ${driver.hasDriverIdCard ? '✅' : '❌'}`);
// //       pdfText.push(`  Document de capacité fourni: ${driver.hasDriverCapacity ? '✅' : '❌'}`);
// //     });
// //   } else {
// //     pdfText.push('Aucun chauffeur enregistré');
// //   }
// //   pdfText.push('');
  
// //   // ========== DOCUMENT STATUS ==========
// //   pdfText.push('4. STATUT DES DOCUMENTS');
// //   pdfText.push('-'.repeat(40));
  
// //   if (documentStatus) {
// //     // Documents fournis
// //     if (documentStatus.provided && documentStatus.provided.length > 0) {
// //       pdfText.push('\nDocuments fournis:');
// //       documentStatus.provided.forEach(doc => {
// //         pdfText.push(`  ${getDocumentStatusEmoji('provided')} ${doc.label}: ${doc.message || `${doc.fileCount} fichier(s)`}`);
// //       });
// //     }
    
// //     // Documents ignorés
// //     if (documentStatus.skipped && documentStatus.skipped.length > 0) {
// //       pdfText.push('\nDocuments ignorés:');
// //       documentStatus.skipped.forEach(doc => {
// //         pdfText.push(`  ${getDocumentStatusEmoji('skipped')} ${doc.label}: ${doc.message || 'Ignoré'}`);
// //       });
// //     }
    
// //     // Documents manquants
// //     if (documentStatus.missing && documentStatus.missing.length > 0) {
// //       pdfText.push('\nDocuments manquants:');
// //       documentStatus.missing.forEach(doc => {
// //         pdfText.push(`  ${getDocumentStatusEmoji('missing')} ${doc.label}: ${doc.message || 'Requis non fourni'}`);
// //       });
// //     }
// //   }
// //   pdfText.push('');
  
// //   // ========== QR CODES ==========
// //   pdfText.push('5. CODES QR GÉNÉRÉS');
// //   pdfText.push('-'.repeat(40));
// //   pdfText.push(`QR code véhicule: ${data.vehicleQrGenerated ? '✅ Généré' : '❌ Non généré'}`);
// //   pdfText.push(`QR codes chauffeurs: ${data.driverQrsGenerated || 0} généré(s)`);
  
// //   // ========== MATCHED DRIVER INFO (if any) ==========
// //   if (verification?.matchedDriverData) {
// //     pdfText.push('\n6. CHAUFFEUR CORRESPONDANT TROUVÉ');
// //     pdfText.push('-'.repeat(40));
// //     pdfText.push(`Nom: ${formatValue(verification.matchedDriverData.name)}`);
// //     pdfText.push(`Téléphone: ${formatValue(verification.matchedDriverData.phone)}`);
// //     pdfText.push(`Numéro de permis: ${formatValue(verification.matchedDriverData.license_number)}`);
// //   }
  
// //   // ========== PAYMENT INFO ==========
// //   if (verification?.isPaymentMade) {
// //     pdfText.push('\n7. INFORMATIONS DE PAIEMENT');
// //     pdfText.push('-'.repeat(40));
// //     pdfText.push(`Paiement effectué: Oui`);
// //     if (verification.paymentInfo) {
// //       pdfText.push(`Date: ${formatDate(verification.paymentInfo.date)}`);
// //       pdfText.push(`Montant: ${formatValue(verification.paymentInfo.amount)} FCFA`);
// //       pdfText.push(`Référence: ${formatValue(verification.paymentInfo.reference)}`);
// //     }
// //   }
  
// //   // ========== FOOTER ==========
// //   pdfText.push('');
// //   pdfText.push('='.repeat(60));
// //   pdfText.push('Document généré automatiquement par Taxi de Ville Yaoundé');
// //   pdfText.push('Pour toute question, contactez notre support.');
// //   pdfText.push('='.repeat(60));

// //   return pdfText.join('\n');
// // };

// // export const generateSummaryPDF = async (data) => {
// //   try {
// //     const pdfContent = generatePDFContent(data);
    
// //     if (Platform.OS === 'web') {
// //       // For web, create a text file
// //       const blob = new Blob([pdfContent], { type: 'text/plain' });
// //       const url = window.URL.createObjectURL(blob);
// //       const link = document.createElement('a');
// //       link.href = url;
// //       link.download = `recapitulatif_verification_${data.verification?.verificationId || Date.now()}.txt`;
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
// //       window.URL.revokeObjectURL(url);
// //       return { success: true };
// //     } else {
// //       // Native: Save to file system as text file
// //       const fileName = `recapitulatif_verification_${data.verification?.verificationId || Date.now()}.txt`;
// //       const filePath = `${FileSystem.cacheDirectory}${fileName}`;
      
// //       await FileSystem.writeAsStringAsync(filePath, pdfContent, {
// //         encoding: FileSystem.EncodingType.UTF8,
// //       });
      
// //       if (await Sharing.isAvailableAsync()) {
// //         await Sharing.shareAsync(filePath);
// //       }
      
// //       return { success: true, filePath };
// //     }
// //   } catch (error) {
// //     console.error('Error generating PDF: - pdfGenerator.js:267', error);
// //     return { success: false, error };
// //   }
// // };

// // src/utils/pdfGenerator.js
// import { Platform } from 'react-native';
// import * as FileSystem from 'expo-file-system';
// import * as Sharing from 'expo-sharing';
// import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

// // App colors
// const COLORS = {
//   primary: '#024A59',
//   secondary: '#D99178',
//   teal: '#1CA7AE',
//   text: '#0b1a1f',
//   muted: '#6B7280',
//   success: '#16A34A',
//   warning: '#F59E0B',
//   error: '#DC2626',
//   border: '#E5E7EB',
// };

// // Logo as base64 (you'll need to replace this with your actual logo)
// // You can convert your logo to base64 using online tools
// const LOGO_BASE64 = 'iVBORw0KGgoAAAANSUhEUgAA...'; // Replace with your actual logo base64

// // Translation dictionaries
// const translations = {
//   fr: {
//     title: 'RÉCAPITULATIF DE LA VÉRIFICATION',
//     generatedOn: 'Date de génération',
//     verificationId: 'ID de vérification',
//     role: 'Rôle',
//     owner: 'Propriétaire',
//     driver: 'Chauffeur',
    
//     vehicleInfo: 'INFORMATIONS DU VÉHICULE',
//     registration: 'Immatriculation',
//     brand: 'Marque',
//     model: 'Modèle',
//     chassisNumber: 'Numéro de chassis',
//     firstRegYear: 'Année de 1ère immatriculation',
//     seats: 'Nombre de places',
//     municipality: 'Municipalité',
//     blueCardNumber: 'Numéro de carte bleue',
//     blueCardDate: 'Date de carte bleue',
//     macaronNumber: 'Numéro de macaron',
//     doorNumber: 'Numéro de portière',
//     insuranceValid: 'Vignette d\'assurance valide',
    
//     techInspection: 'CONTRÔLE TECHNIQUE',
//     techValid: 'Valide',
//     techDate: 'Date du contrôle',
    
//     ownerInfo: 'INFORMATIONS DU PROPRIÉTAIRE',
//     ownerType: 'Type',
//     physicalPerson: 'Personne physique',
//     legalEntity: 'Personne morale',
//     fullName: 'Nom complet',
//     firstName: 'Prénom',
//     lastName: 'Nom',
//     gender: 'Sexe',
//     companyName: 'Nom de l\'entreprise',
//     phone: 'Téléphone',
//     email: 'Email',
//     cinNumber: 'Numéro CIN',
//     taxpayerNumber: 'Numéro contribuable',
//     syndicate: 'Syndicat',
//     licenseNumber: 'Numéro de licence',
//     licenseDate: 'Date de licence',
//     taxisOperated: 'Nombre de taxis exploités',
//     hasProcuration: 'A procuration',
//     yes: 'Oui',
//     no: 'Non',
//     skipped: 'Ignoré',
    
//     driversInfo: 'INFORMATIONS DES CHAUFFEURS',
//     mainDriver: 'Chauffeur principal',
//     driver: 'Chauffeur',
//     personId: 'ID Personne',
//     birthDate: 'Date de naissance',
//     licenseCategory: 'Catégorie de permis',
//     capacityNumber: 'Numéro de capacité',
//     hasCapacityDoc: 'A document de capacité',
//     hasSecureBadge: 'A badge de sécurité',
//     notSpecified: 'Non spécifié',
    
//     documents: 'DOCUMENTS FOURNIS',
//     documentStatus: 'STATUT DES DOCUMENTS',
//     provided: 'Documents fournis',
//     skipped: 'Documents ignorés',
//     missing: 'Documents manquants',
//     filesCount: 'fichier(s)',
    
//     qrCodes: 'CODES QR GÉNÉRÉS',
//     vehicleQr: 'QR code véhicule',
//     driverQrs: 'QR codes chauffeurs',
//     generated: 'Généré',
//     notGenerated: 'Non généré',
    
//     matchedDriver: 'CHAUFFEUR CORRESPONDANT TROUVÉ',
//     paymentInfo: 'INFORMATIONS DE PAIEMENT',
//     paymentMade: 'Paiement effectué',
//     amount: 'Montant',
//     reference: 'Référence',
    
//     footer: 'Document généré automatiquement par Taxi de Ville Yaoundé',
//     support: 'Pour toute question, contactez notre support.',
    
//     notSpecifiedValue: 'Non spécifié',
//   },
//   en: {
//     title: 'VERIFICATION SUMMARY',
//     generatedOn: 'Generated on',
//     verificationId: 'Verification ID',
//     role: 'Role',
//     owner: 'Owner',
//     driver: 'Driver',
    
//     vehicleInfo: 'VEHICLE INFORMATION',
//     registration: 'Registration',
//     brand: 'Brand',
//     model: 'Model',
//     chassisNumber: 'Chassis number',
//     firstRegYear: 'First registration year',
//     seats: 'Seats',
//     municipality: 'Municipality',
//     blueCardNumber: 'Blue card number',
//     blueCardDate: 'Blue card date',
//     macaronNumber: 'Macaron number',
//     doorNumber: 'Door number',
//     insuranceValid: 'Insurance sticker valid',
    
//     techInspection: 'TECHNICAL INSPECTION',
//     techValid: 'Valid',
//     techDate: 'Inspection date',
    
//     ownerInfo: 'OWNER INFORMATION',
//     ownerType: 'Type',
//     physicalPerson: 'Physical person',
//     legalEntity: 'Legal entity',
//     fullName: 'Full name',
//     firstName: 'First name',
//     lastName: 'Last name',
//     gender: 'Gender',
//     companyName: 'Company name',
//     phone: 'Phone',
//     email: 'Email',
//     cinNumber: 'ID number',
//     taxpayerNumber: 'Taxpayer number',
//     syndicate: 'Syndicate',
//     licenseNumber: 'License number',
//     licenseDate: 'License date',
//     taxisOperated: 'Taxis operated',
//     hasProcuration: 'Has power of attorney',
//     yes: 'Yes',
//     no: 'No',
//     skipped: 'Skipped',
    
//     driversInfo: 'DRIVERS INFORMATION',
//     mainDriver: 'Main driver',
//     driver: 'Driver',
//     personId: 'Person ID',
//     birthDate: 'Birth date',
//     licenseCategory: 'License category',
//     capacityNumber: 'Capacity number',
//     hasCapacityDoc: 'Has capacity document',
//     hasSecureBadge: 'Has security badge',
//     notSpecified: 'Not specified',
    
//     documents: 'PROVIDED DOCUMENTS',
//     documentStatus: 'DOCUMENT STATUS',
//     provided: 'Provided documents',
//     skipped: 'Skipped documents',
//     missing: 'Missing documents',
//     filesCount: 'file(s)',
    
//     qrCodes: 'GENERATED QR CODES',
//     vehicleQr: 'Vehicle QR code',
//     driverQrs: 'Driver QR codes',
//     generated: 'Generated',
//     notGenerated: 'Not generated',
    
//     matchedDriver: 'MATCHED DRIVER FOUND',
//     paymentInfo: 'PAYMENT INFORMATION',
//     paymentMade: 'Payment made',
//     amount: 'Amount',
//     reference: 'Reference',
    
//     footer: 'Document automatically generated by Taxi de Ville Yaoundé',
//     support: 'For any questions, please contact our support.',
    
//     notSpecifiedValue: 'Not specified',
//   }
// };

// const formatDate = (date, lang) => {
//   if (!date) return translations[lang].notSpecifiedValue;
//   try {
//     return new Date(date).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-US', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });
//   } catch {
//     return translations[lang].notSpecifiedValue;
//   }
// };

// const formatValue = (value, lang) => {
//   if (value === null || value === undefined || value === '') return translations[lang].notSpecifiedValue;
//   if (typeof value === 'boolean') return value ? translations[lang].yes : translations[lang].no;
//   return String(value);
// };

// const getDocumentStatusEmoji = (status, lang) => {
//   return status === 'provided' ? '✅' : status === 'skipped' ? '⏭️' : '❌';
// };

// const drawSectionHeader = (page, text, y, font, size = 14) => {
//   page.drawText(text, {
//     x: 50,
//     y,
//     size,
//     font,
//     color: rgb(0.02, 0.29, 0.35), // COLORS.primary
//   });
  
//   // Draw underline
//   page.drawLine({
//     start: { x: 50, y: y - 5 },
//     end: { x: 550, y: y - 5 },
//     thickness: 1,
//     color: rgb(0.02, 0.29, 0.35),
//   });
  
//   return y - 25;
// };

// const drawLabelValue = (page, label, value, y, font, boldFont, x = 50, labelWidth = 200) => {
//   page.drawText(label, {
//     x,
//     y,
//     size: 10,
//     font: boldFont,
//     color: rgb(0.42, 0.45, 0.5), // COLORS.muted
//   });
  
//   page.drawText(value, {
//     x: x + labelWidth,
//     y,
//     size: 10,
//     font,
//     color: rgb(0.04, 0.1, 0.12), // COLORS.text
//   });
  
//   return y - 18;
// };
// const generateSummaryPDF = async (data, language = 'fr') => {
//   try {
//     const {
//       verification,
//       documentStatus,
//       submissionDate
//     } = data;
    
//     const t = translations[language] || translations.fr;
    
//     // Create a new PDF document
//     const pdfDoc = await PDFDocument.create();
    
//     // Add a page
//     let page = pdfDoc.addPage([612, 792]); // US Letter size
    
//     // Embed fonts
//     const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
//     let y = 750; // Start Y position
    
//     // ========== HEADER ==========
//     // Draw logo (if you have a logo)
//     // if (LOGO_BASE64) {
//     //   try {
//     //     const logoImage = await pdfDoc.embedPng(LOGO_BASE64);
//     //     page.drawImage(logoImage, {
//     //       x: 50,
//     //       y: y - 40,
//     //       width: 60,
//     //       height: 60,
//     //     });
//     //   } catch (e) {
//     //     console.log('Could not embed logo');
//     //   }
//     // }
    
//     // Draw title
//     page.drawText(t.title, {
//       x: 150,
//       y: y - 15,
//       size: 18,
//       font: helveticaBold,
//       color: rgb(0.02, 0.29, 0.35), // COLORS.primary
//     });
    
//     y -= 45;
    
//     // Draw metadata
//     page.drawText(`${t.generatedOn}: ${formatDate(submissionDate, language)}`, {
//       x: 50,
//       y,
//       size: 10,
//       font: helveticaFont,
//       color: rgb(0.42, 0.45, 0.5),
//     });
    
//     y -= 15;
    
//     page.drawText(`${t.verificationId}: ${verification?.verificationId || t.notSpecifiedValue}`, {
//       x: 50,
//       y,
//       size: 10,
//       font: helveticaFont,
//       color: rgb(0.42, 0.45, 0.5),
//     });
    
//     y -= 15;
    
//     page.drawText(`${t.role}: ${verification?.actorRole === 'OWNER' ? t.owner : t.driver}`, {
//       x: 50,
//       y,
//       size: 10,
//       font: helveticaFont,
//       color: rgb(0.42, 0.45, 0.5),
//     });
    
//     y -= 30;
    
//     // ========== VEHICLE INFORMATION ==========
//     y = drawSectionHeader(page, t.vehicleInfo, y, helveticaBold);
    
//     const vehicle = verification?.vehicle || {};
//     const vehicleAdmin = verification?.vehicleAdmin || {};
    
//     y = drawLabelValue(page, `${t.registration}:`, formatValue(vehicle.registrationNumber || verification?.numeimma, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.brand}:`, formatValue(vehicle.brand, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.model}:`, formatValue(vehicle.model, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.chassisNumber}:`, formatValue(vehicle.chassisNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.firstRegYear}:`, formatValue(vehicle.firstRegistrationYear, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.seats}:`, formatValue(vehicle.seats, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.municipality}:`, formatValue(vehicle.municipality || vehicleAdmin.municipality, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.blueCardNumber}:`, formatValue(vehicle.blueCardNumber || vehicleAdmin.blueCardNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.blueCardDate}:`, formatValue(vehicle.blueCardIssueDate || vehicleAdmin.blueCardIssueDate, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.macaronNumber}:`, formatValue(vehicle.macaronNumber || vehicleAdmin.macaronNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.doorNumber}:`, formatValue(vehicle.doorNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.insuranceValid}:`, formatValue(vehicle.insuranceStickerValid, language), y, helveticaFont, helveticaBold);
    
//     y -= 10;
    
//     // Technical inspection
//     if (vehicleAdmin) {
//       y = drawSectionHeader(page, t.techInspection, y, helveticaBold);
//       y = drawLabelValue(page, `${t.techValid}:`, formatValue(vehicleAdmin.technicalInspectionValid, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.techDate}:`, formatValue(vehicleAdmin.technicalInspectionDate, language), y, helveticaFont, helveticaBold);
//       y -= 10;
//     }
    
//     // Check if we need a new page
//     if (y < 100) {
//       page = pdfDoc.addPage([612, 792]);
//       y = 750;
//     }
    
//     // ========== OWNER INFORMATION ==========
//     y = drawSectionHeader(page, t.ownerInfo, y, helveticaBold);
    
//     const owner = verification?.owner || {};
    
//     y = drawLabelValue(page, `${t.ownerType}:`, owner.type === 'PHYSIQUE' ? t.physicalPerson : t.legalEntity, y, helveticaFont, helveticaBold);
    
//     if (owner.type === 'PHYSIQUE') {
//       y = drawLabelValue(page, `${t.fullName}:`, formatValue(owner.fullName || `${owner.firstName || ''} ${owner.lastName || ''}`, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.firstName}:`, formatValue(owner.firstName, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.lastName}:`, formatValue(owner.lastName, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.gender}:`, formatValue(owner.gender, language), y, helveticaFont, helveticaBold);
//     } else {
//       y = drawLabelValue(page, `${t.companyName}:`, formatValue(owner.organizationName, language), y, helveticaFont, helveticaBold);
//     }
    
//     y = drawLabelValue(page, `${t.phone}:`, formatValue(owner.phone, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.email}:`, formatValue(owner.email, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(owner.cinNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(owner.taxpayerNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.syndicate}:`, formatValue(owner.ownerSyndicate, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(owner.categoryLicenseNumber || vehicleAdmin.ownerCatLicenseNumber, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.licenseDate}:`, formatValue(owner.categoryLicenseIssueDate || vehicleAdmin.ownerCatLicenseIssueDate, language), y, helveticaFont, helveticaBold);
//     y = drawLabelValue(page, `${t.taxisOperated}:`, formatValue(owner.taxisOperated || vehicleAdmin.taxisOperated, language), y, helveticaFont, helveticaBold);
    
//     let procurationStatus = t.no;
//     if (owner.hasProcuration) procurationStatus = t.yes;
//     else if (owner.skipProcuration) procurationStatus = t.skipped;
    
//     y = drawLabelValue(page, `${t.hasProcuration}:`, procurationStatus, y, helveticaFont, helveticaBold);
    
//     y -= 10;
    
//     // Check if we need a new page
//     if (y < 100) {
//       page = pdfDoc.addPage([612, 792]);
//       y = 750;
//     }
    
//     // ========== DRIVER INFORMATION ==========
//     y = drawSectionHeader(page, t.driversInfo, y, helveticaBold);
    
//     const drivers = verification?.drivers || [];
//     const driverObj = verification?.driver || {};
//     const driverDocuments = verification?.driverDocuments || {};
    
//     // If this is driver workflow (single driver)
//     if (verification?.actorRole === 'DRIVER' && driverObj.personId) {
//       page.drawText(`${t.mainDriver}:`, {
//         x: 50,
//         y: y + 5,
//         size: 12,
//         font: helveticaBold,
//         color: rgb(0.85, 0.57, 0.47), // COLORS.secondary
//       });
      
//       y -= 15;
      
//       y = drawLabelValue(page, `${t.personId}:`, formatValue(driverObj.personId, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.fullName}:`, formatValue(driverObj.fullName || `${driverObj.firstName || ''} ${driverObj.lastName || ''}`, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.phone}:`, formatValue(driverObj.phone, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.email}:`, formatValue(driverObj.email, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.birthDate}:`, formatValue(driverObj.birthDate, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.gender}:`, formatValue(driverObj.gender, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(driverObj.cinNumber, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(driverObj.taxpayerNumber, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(driverObj.licenseNumber, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.licenseCategory}:`, formatValue(driverObj.licenseCategory, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.syndicate}:`, formatValue(driverObj.driverSyndicate, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.capacityNumber}:`, formatValue(driverObj.capacityNumber, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.hasCapacityDoc}:`, driverObj.hasCapacityDoc ? t.yes : t.no, y, helveticaFont, helveticaBold);
      
//       let secureBadgeStatus = t.notSpecified;
//       if (driverObj.secureBadge === true) secureBadgeStatus = t.yes;
//       else if (driverObj.secureBadge === false) secureBadgeStatus = t.no;
      
//       y = drawLabelValue(page, `${t.hasSecureBadge}:`, secureBadgeStatus, y, helveticaFont, helveticaBold);
      
//       // Documents for this driver
//       const docs = driverDocuments[driverObj.personId] || {};
//       y = drawLabelValue(page, `${t.documents}:`, '', y, helveticaFont, helveticaBold);
//       y -= 15;
      
//       page.drawText(`  ${t.photo}: ${docs.photo ? '✅' : '❌'}`, {
//         x: 70,
//         y,
//         size: 10,
//         font: helveticaFont,
//         color: rgb(0.04, 0.1, 0.12),
//       });
//       y -= 15;
      
//       page.drawText(`  ${t.licenseNumber}: ${docs.license ? '✅' : '❌'}`, {
//         x: 70,
//         y,
//         size: 10,
//         font: helveticaFont,
//         color: rgb(0.04, 0.1, 0.12),
//       });
//       y -= 15;
      
//       page.drawText(`  ${t.cinNumber}: ${docs.idCard ? '✅' : '❌'}`, {
//         x: 70,
//         y,
//         size: 10,
//         font: helveticaFont,
//         color: rgb(0.04, 0.1, 0.12),
//       });
//       y -= 15;
      
//       page.drawText(`  ${t.capacityNumber}: ${docs.capacity ? '✅' : '❌'}`, {
//         x: 70,
//         y,
//         size: 10,
//         font: helveticaFont,
//         color: rgb(0.04, 0.1, 0.12),
//       });
//       y -= 15;
      
//     } 
//     // If this is owner workflow (multiple drivers)
//     else if (drivers.length > 0) {
//       drivers.forEach((driver, index) => {
//         // Check if we need a new page
//         if (y < 150) {
//           page = pdfDoc.addPage([612, 792]);
//           y = 750;
//         }
        
//         page.drawText(`${t.driver} ${index + 1}:`, {
//           x: 50,
//           y: y + 5,
//           size: 12,
//           font: helveticaBold,
//           color: rgb(0.85, 0.57, 0.47),
//         });
        
//         y -= 15;
        
//         y = drawLabelValue(page, `${t.personId}:`, formatValue(driver.personId, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.fullName}:`, formatValue(driver.name, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.phone}:`, formatValue(driver.phone, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.email}:`, formatValue(driver.email, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.birthDate}:`, formatValue(driver.birthDate, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.gender}:`, formatValue(driver.gender, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(driver.cinNumber, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(driver.taxpayerNumber, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(driver.licenseNumber, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.licenseCategory}:`, formatValue(driver.licenseCategory, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.syndicate}:`, formatValue(driver.driverSyndicate, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.capacityNumber}:`, formatValue(driver.capacityNumber, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.hasCapacityDoc}:`, driver.hasCapacityDoc ? t.yes : t.no, y, helveticaFont, helveticaBold);
        
//         let secureBadgeStatus = t.notSpecified;
//         if (driver.secureBadge === true) secureBadgeStatus = t.yes;
//         else if (driver.secureBadge === false) secureBadgeStatus = t.no;
        
//         y = drawLabelValue(page, `${t.hasSecureBadge}:`, secureBadgeStatus, y, helveticaFont, helveticaBold);
        
//         // Document status
//         y = drawLabelValue(page, `${t.documents}:`, '', y, helveticaFont, helveticaBold);
//         y -= 15;
        
//         page.drawText(`  ${t.photo}: ${driver.hasDriverPhoto ? '✅' : '❌'}`, {
//           x: 70,
//           y,
//           size: 10,
//           font: helveticaFont,
//           color: rgb(0.04, 0.1, 0.12),
//         });
//         y -= 15;
        
//         page.drawText(`  ${t.licenseNumber}: ${driver.hasDriverLicense ? '✅' : '❌'}`, {
//           x: 70,
//           y,
//           size: 10,
//           font: helveticaFont,
//           color: rgb(0.04, 0.1, 0.12),
//         });
//         y -= 15;
        
//         page.drawText(`  ${t.cinNumber}: ${driver.hasDriverIdCard ? '✅' : '❌'}`, {
//           x: 70,
//           y,
//           size: 10,
//           font: helveticaFont,
//           color: rgb(0.04, 0.1, 0.12),
//         });
//         y -= 15;
        
//         page.drawText(`  ${t.capacityNumber}: ${driver.hasDriverCapacity ? '✅' : '❌'}`, {
//           x: 70,
//           y,
//           size: 10,
//           font: helveticaFont,
//           color: rgb(0.04, 0.1, 0.12),
//         });
//         y -= 20;
//       });
//     } else {
//       page.drawText(t.notSpecified, {
//         x: 50,
//         y: y - 5,
//         size: 10,
//         font: helveticaFont,
//         color: rgb(0.42, 0.45, 0.5),
//       });
//       y -= 20;
//     }
    
//     y -= 10;
    
//     // Check if we need a new page
//     if (y < 150) {
//       page = pdfDoc.addPage([612, 792]);
//       y = 750;
//     }
    
//     // ========== DOCUMENT STATUS ==========
//     y = drawSectionHeader(page, t.documentStatus, y, helveticaBold);
    
//     if (documentStatus) {
//       // Provided documents
//       if (documentStatus.provided && documentStatus.provided.length > 0) {
//         page.drawText(`${t.provided}:`, {
//           x: 50,
//           y: y + 5,
//           size: 11,
//           font: helveticaBold,
//           color: rgb(0.09, 0.63, 0.52), // COLORS.teal
//         });
//         y -= 15;
        
//         documentStatus.provided.forEach(doc => {
//           page.drawText(`  ${getDocumentStatusEmoji('provided')} ${doc.label}: ${doc.message || `${doc.fileCount} ${t.filesCount}`}`, {
//             x: 50,
//             y,
//             size: 10,
//             font: helveticaFont,
//             color: rgb(0.04, 0.1, 0.12),
//           });
//           y -= 15;
//         });
//       }
      
//       // Skipped documents
//       if (documentStatus.skipped && documentStatus.skipped.length > 0) {
//         page.drawText(`${t.skipped}:`, {
//           x: 50,
//           y: y + 5,
//           size: 11,
//           font: helveticaBold,
//           color: rgb(0.96, 0.65, 0.14), // COLORS.warning
//         });
//         y -= 15;
        
//         documentStatus.skipped.forEach(doc => {
//           page.drawText(`  ${getDocumentStatusEmoji('skipped')} ${doc.label}: ${doc.message || t.skipped}`, {
//             x: 50,
//             y,
//             size: 10,
//             font: helveticaFont,
//             color: rgb(0.04, 0.1, 0.12),
//           });
//           y -= 15;
//         });
//       }
      
//       // Missing documents
//       if (documentStatus.missing && documentStatus.missing.length > 0) {
//         page.drawText(`${t.missing}:`, {
//           x: 50,
//           y: y + 5,
//           size: 11,
//           font: helveticaBold,
//           color: rgb(0.86, 0.15, 0.15), // COLORS.error
//         });
//         y -= 15;
        
//         documentStatus.missing.forEach(doc => {
//           page.drawText(`  ${getDocumentStatusEmoji('missing')} ${doc.label}: ${doc.message || t.missing}`, {
//             x: 50,
//             y,
//             size: 10,
//             font: helveticaFont,
//             color: rgb(0.04, 0.1, 0.12),
//           });
//           y -= 15;
//         });
//       }
//     }
    
//     y -= 10;
    
//     // ========== QR CODES ==========
//     y = drawSectionHeader(page, t.qrCodes, y, helveticaBold);
    
//     const vehicleQrStatus = data.vehicleQrGenerated ? `✅ ${t.generated}` : `❌ ${t.notGenerated}`;
//     y = drawLabelValue(page, `${t.vehicleQr}:`, vehicleQrStatus, y, helveticaFont, helveticaBold);
    
//     const driverQrStatus = `${data.driverQrsGenerated || 0} ${t.generated.toLowerCase()}`;
//     y = drawLabelValue(page, `${t.driverQrs}:`, driverQrStatus, y, helveticaFont, helveticaBold);
    
//     y -= 10;
    
//     // ========== MATCHED DRIVER ==========
//     if (verification?.matchedDriverData) {
//       // Check if we need a new page
//       if (y < 100) {
//         page = pdfDoc.addPage([612, 792]);
//         y = 750;
//       }
      
//       y = drawSectionHeader(page, t.matchedDriver, y, helveticaBold);
//       y = drawLabelValue(page, `${t.fullName}:`, formatValue(verification.matchedDriverData.name, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.phone}:`, formatValue(verification.matchedDriverData.phone, language), y, helveticaFont, helveticaBold);
//       y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(verification.matchedDriverData.license_number, language), y, helveticaFont, helveticaBold);
//       y -= 10;
//     }
    
//     // ========== PAYMENT INFO ==========
//     if (verification?.isPaymentMade) {
//       // Check if we need a new page
//       if (y < 100) {
//         page = pdfDoc.addPage([612, 792]);
//         y = 750;
//       }
      
//       y = drawSectionHeader(page, t.paymentInfo, y, helveticaBold);
//       y = drawLabelValue(page, `${t.paymentMade}:`, t.yes, y, helveticaFont, helveticaBold);
      
//       if (verification.paymentInfo) {
//         y = drawLabelValue(page, `${t.generatedOn}:`, formatDate(verification.paymentInfo.date, language), y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.amount}:`, `${verification.paymentInfo.amount || '500'} FCFA`, y, helveticaFont, helveticaBold);
//         y = drawLabelValue(page, `${t.reference}:`, formatValue(verification.paymentInfo.reference, language), y, helveticaFont, helveticaBold);
//       }
      
//       y -= 10;
//     }
    
//     // ========== FOOTER ==========
//     // Ensure footer is on its own page if needed
//     if (y < 80) {
//       page = pdfDoc.addPage([612, 792]);
//       y = 750;
//     }
    
//     // Draw footer line
//     page.drawLine({
//       start: { x: 50, y: y - 10 },
//       end: { x: 550, y: y - 10 },
//       thickness: 1,
//       color: rgb(0.9, 0.9, 0.9),
//     });
    
//     y -= 25;
    
//     page.drawText(t.footer, {
//       x: 50,
//       y,
//       size: 9,
//       font: helveticaFont,
//       color: rgb(0.42, 0.45, 0.5),
//     });
    
//     y -= 15;
    
//     page.drawText(t.support, {
//       x: 50,
//       y,
//       size: 9,
//       font: helveticaFont,
//       color: rgb(0.42, 0.45, 0.5),
//     });
    
//     // Save the PDF
//     const pdfBytes = await pdfDoc.save();
    
//     if (Platform.OS === 'web') {
//       // Web: Create blob and download
//       const blob = new Blob([pdfBytes], { type: 'application/pdf' });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `recapitulatif_verification_${verification?.verificationId || Date.now()}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       return { success: true };
//     } else {
//       // Native: Save to file system and share
//       const fileName = `recapitulatif_verification_${verification?.verificationId || Date.now()}.pdf`;
//       const filePath = `${FileSystem.cacheDirectory}${fileName}`;
      
//       // Convert array buffer to base64
//       const base64 = Buffer.from(pdfBytes).toString('base64');
      
//       await FileSystem.writeAsStringAsync(filePath, base64, {
//         encoding: FileSystem.EncodingType.Base64,
//       });
      
//       if (await Sharing.isAvailableAsync()) {
//         await Sharing.shareAsync(filePath);
//       }
      
//       return { success: true, filePath };
//     }
//   } catch (error) {
//     console.error('Error generating PDF: - pdfGenerator.js:1051', error);
//     return { success: false, error };
//   }
// };

// export default generateSummaryPDF;

// src/utils/pdfGenerator.js
import { Platform } from 'react-native';
import * as FileSystem from 'expo-file-system';
import * as Sharing from 'expo-sharing';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

// App colors
const COLORS = {
  primary: '#024A59',
  secondary: '#D99178',
  teal: '#1CA7AE',
  text: '#0b1a1f',
  muted: '#6B7280',
  success: '#16A34A',
  warning: '#F59E0B',
  error: '#DC2626',
  border: '#E5E7EB',
};

// Translation dictionaries
const translations = {
  fr: {
    title: 'RÉCAPITULATIF DE LA VÉRIFICATION',
    generatedOn: 'Date de génération',
    verificationId: 'ID de vérification',
    role: 'Rôle',
    owner: 'Propriétaire',
    driver: 'Chauffeur',
    
    vehicleInfo: 'INFORMATIONS DU VÉHICULE',
    registration: 'Immatriculation',
    brand: 'Marque',
    model: 'Modèle',
    chassisNumber: 'Numéro de chassis',
    firstRegYear: 'Année de 1ère immatriculation',
    seats: 'Nombre de places',
    municipality: 'Municipalité',
    blueCardNumber: 'Numéro de carte bleue',
    blueCardDate: 'Date de carte bleue',
    macaronNumber: 'Numéro de macaron',
    doorNumber: 'Numéro de portière',
    insuranceValid: 'Vignette d\'assurance valide',
    
    techInspection: 'CONTRÔLE TECHNIQUE',
    techValid: 'Valide',
    techDate: 'Date du contrôle',
    
    ownerInfo: 'INFORMATIONS DU PROPRIÉTAIRE',
    ownerType: 'Type',
    physicalPerson: 'Personne physique',
    legalEntity: 'Personne morale',
    fullName: 'Nom complet',
    firstName: 'Prénom',
    lastName: 'Nom',
    gender: 'Sexe',
    companyName: 'Nom de l\'entreprise',
    phone: 'Téléphone',
    email: 'Email',
    cinNumber: 'Numéro CIN',
    taxpayerNumber: 'Numéro contribuable',
    syndicate: 'Syndicat',
    licenseNumber: 'Numéro de licence',
    licenseDate: 'Date de licence',
    taxisOperated: 'Nombre de taxis exploités',
    hasProcuration: 'A procuration',
    yes: 'Oui',
    no: 'Non',
    skipped: 'Ignoré',
    
    driversInfo: 'INFORMATIONS DES CHAUFFEURS',
    mainDriver: 'Chauffeur principal',
    driver: 'Chauffeur',
    personId: 'ID Personne',
    birthDate: 'Date de naissance',
    licenseCategory: 'Catégorie de permis',
    capacityNumber: 'Numéro de capacité',
    hasCapacityDoc: 'A document de capacité',
    hasSecureBadge: 'A badge de sécurité',
    notSpecified: 'Non spécifié',
    
    documents: 'DOCUMENTS FOURNIS',
    documentStatus: 'STATUT DES DOCUMENTS',
    provided: 'Documents fournis',
    skipped: 'Documents ignorés',
    missing: 'Documents manquants',
    filesCount: 'fichier(s)',
    
    qrCodes: 'CODES QR GÉNÉRÉS',
    vehicleQr: 'QR code véhicule',
    driverQrs: 'QR codes chauffeurs',
    generated: 'Généré',
    notGenerated: 'Non généré',
    
    matchedDriver: 'CHAUFFEUR CORRESPONDANT TROUVÉ',
    paymentInfo: 'INFORMATIONS DE PAIEMENT',
    paymentMade: 'Paiement effectué',
    amount: 'Montant',
    reference: 'Référence',
    
    footer: 'Document généré automatiquement par Taxi de Ville Yaoundé',
    support: 'Pour toute question, contactez notre support.',
    
    notSpecifiedValue: 'Non spécifié',
    
    // Symbols for document status
    symbolProvided: '[X]',
    symbolSkipped: '[-]',
    symbolMissing: '[ ]',
  },
  en: {
    title: 'VERIFICATION SUMMARY',
    generatedOn: 'Generated on',
    verificationId: 'Verification ID',
    role: 'Role',
    owner: 'Owner',
    driver: 'Driver',
    
    vehicleInfo: 'VEHICLE INFORMATION',
    registration: 'Registration',
    brand: 'Brand',
    model: 'Model',
    chassisNumber: 'Chassis number',
    firstRegYear: 'First registration year',
    seats: 'Seats',
    municipality: 'Municipality',
    blueCardNumber: 'Blue card number',
    blueCardDate: 'Blue card date',
    macaronNumber: 'Macaron number',
    doorNumber: 'Door number',
    insuranceValid: 'Insurance sticker valid',
    
    techInspection: 'TECHNICAL INSPECTION',
    techValid: 'Valid',
    techDate: 'Inspection date',
    
    ownerInfo: 'OWNER INFORMATION',
    ownerType: 'Type',
    physicalPerson: 'Physical person',
    legalEntity: 'Legal entity',
    fullName: 'Full name',
    firstName: 'First name',
    lastName: 'Last name',
    gender: 'Gender',
    companyName: 'Company name',
    phone: 'Phone',
    email: 'Email',
    cinNumber: 'ID number',
    taxpayerNumber: 'Taxpayer number',
    syndicate: 'Syndicate',
    licenseNumber: 'License number',
    licenseDate: 'License date',
    taxisOperated: 'Taxis operated',
    hasProcuration: 'Has power of attorney',
    yes: 'Yes',
    no: 'No',
    skipped: 'Skipped',
    
    driversInfo: 'DRIVERS INFORMATION',
    mainDriver: 'Main driver',
    driver: 'Driver',
    personId: 'Person ID',
    birthDate: 'Birth date',
    licenseCategory: 'License category',
    capacityNumber: 'Capacity number',
    hasCapacityDoc: 'Has capacity document',
    hasSecureBadge: 'Has security badge',
    notSpecified: 'Not specified',
    
    documents: 'PROVIDED DOCUMENTS',
    documentStatus: 'DOCUMENT STATUS',
    provided: 'Provided documents',
    skipped: 'Skipped documents',
    missing: 'Missing documents',
    filesCount: 'file(s)',
    
    qrCodes: 'GENERATED QR CODES',
    vehicleQr: 'Vehicle QR code',
    driverQrs: 'Driver QR codes',
    generated: 'Generated',
    notGenerated: 'Not generated',
    
    matchedDriver: 'MATCHED DRIVER FOUND',
    paymentInfo: 'PAYMENT INFORMATION',
    paymentMade: 'Payment made',
    amount: 'Amount',
    reference: 'Reference',
    
    footer: 'Document automatically generated by Taxi de Ville Yaoundé',
    support: 'For any questions, please contact our support.',
    
    notSpecifiedValue: 'Not specified',
    
    // Symbols for document status
    symbolProvided: '[X]',
    symbolSkipped: '[-]',
    symbolMissing: '[ ]',
  }
};

const formatDate = (date, lang) => {
  if (!date) return translations[lang].notSpecifiedValue;
  try {
    return new Date(date).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return translations[lang].notSpecifiedValue;
  }
};

const formatValue = (value, lang) => {
  if (value === null || value === undefined || value === '') return translations[lang].notSpecifiedValue;
  if (typeof value === 'boolean') return value ? translations[lang].yes : translations[lang].no;
  return String(value);
};

const getDocumentStatusSymbol = (status, lang) => {
  if (status === 'provided') return translations[lang].symbolProvided;
  if (status === 'skipped') return translations[lang].symbolSkipped;
  return translations[lang].symbolMissing;
};

const drawSectionHeader = (page, text, y, font, size = 14) => {
  page.drawText(text, {
    x: 50,
    y,
    size,
    font,
    color: rgb(0.02, 0.29, 0.35), // COLORS.primary
  });
  
  // Draw underline
  page.drawLine({
    start: { x: 50, y: y - 5 },
    end: { x: 550, y: y - 5 },
    thickness: 1,
    color: rgb(0.02, 0.29, 0.35),
  });
  
  return y - 25;
};

const drawLabelValue = (page, label, value, y, font, boldFont, x = 50, labelWidth = 200) => {
  page.drawText(label, {
    x,
    y,
    size: 10,
    font: boldFont,
    color: rgb(0.42, 0.45, 0.5), // COLORS.muted
  });
  
  page.drawText(value, {
    x: x + labelWidth,
    y,
    size: 10,
    font,
    color: rgb(0.04, 0.1, 0.12), // COLORS.text
  });
  
  return y - 18;
};

const generateSummaryPDF = async (data, language ) => {
    console.log('Generating PDF with language: - pdfGenerator.js:1323', language, data);
  try {
    const {
      verification,
      documentStatus,
      submissionDate
    } = data;
    
    const t = translations[language] || translations.fr;
    
    // Create a new PDF document
    const pdfDoc = await PDFDocument.create();
    
    // Add a page
    let page = pdfDoc.addPage([612, 792]); // US Letter size
    
    // Embed fonts
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    
    let y = 750; // Start Y position
    
    // ========== HEADER ==========
    // Draw title
    page.drawText(t.title, {
      x: 150,
      y: y - 15,
      size: 18,
      font: helveticaBold,
      color: rgb(0.02, 0.29, 0.35), // COLORS.primary
    });
    
    y -= 45;
    
    // Draw metadata
    page.drawText(`${t.generatedOn}: ${formatDate(submissionDate, language)}`, {
      x: 50,
      y,
      size: 10,
      font: helveticaFont,
      color: rgb(0.42, 0.45, 0.5),
    });
    
    y -= 15;
    
    page.drawText(`${t.verificationId}: ${verification?.verificationId || t.notSpecifiedValue}`, {
      x: 50,
      y,
      size: 10,
      font: helveticaFont,
      color: rgb(0.42, 0.45, 0.5),
    });
    
    y -= 15;
    
    page.drawText(`${t.role}: ${verification?.actorRole === 'OWNER' ? t.owner : t.driver}`, {
      x: 50,
      y,
      size: 10,
      font: helveticaFont,
      color: rgb(0.42, 0.45, 0.5),
    });
    
    y -= 30;
    
    // ========== VEHICLE INFORMATION ==========
    y = drawSectionHeader(page, t.vehicleInfo, y, helveticaBold);
    
    const vehicle = verification?.vehicle || {};
    const vehicleAdmin = verification?.vehicleAdmin || {};
    
    y = drawLabelValue(page, `${t.registration}:`, formatValue(vehicle.registrationNumber || verification?.numeimma, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.brand}:`, formatValue(vehicle.brand, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.model}:`, formatValue(vehicle.model, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.chassisNumber}:`, formatValue(vehicle.chassisNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.firstRegYear}:`, formatValue(vehicle.firstRegistrationYear, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.seats}:`, formatValue(vehicle.seats, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.municipality}:`, formatValue(vehicle.municipality || vehicleAdmin.municipality, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.blueCardNumber}:`, formatValue(vehicle.blueCardNumber || vehicleAdmin.blueCardNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.blueCardDate}:`, formatValue(vehicle.blueCardIssueDate || vehicleAdmin.blueCardIssueDate, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.macaronNumber}:`, formatValue(vehicle.macaronNumber || vehicleAdmin.macaronNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.doorNumber}:`, formatValue(vehicle.doorNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.insuranceValid}:`, formatValue(vehicle.insuranceStickerValid, language), y, helveticaFont, helveticaBold);
    
    y -= 10;
    
    // Technical inspection
    if (vehicleAdmin && (vehicleAdmin.technicalInspectionValid !== undefined || vehicleAdmin.technicalInspectionDate)) {
      y = drawSectionHeader(page, t.techInspection, y, helveticaBold);
      y = drawLabelValue(page, `${t.techValid}:`, formatValue(vehicleAdmin.technicalInspectionValid, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.techDate}:`, formatValue(vehicleAdmin.technicalInspectionDate, language), y, helveticaFont, helveticaBold);
      y -= 10;
    }
    
    // Check if we need a new page
    if (y < 100) {
      page = pdfDoc.addPage([612, 792]);
      y = 750;
    }
    
    // ========== OWNER INFORMATION ==========
    y = drawSectionHeader(page, t.ownerInfo, y, helveticaBold);
    
    const owner = verification?.owner || {};
    
    y = drawLabelValue(page, `${t.ownerType}:`, owner.type === 'PHYSIQUE' ? t.physicalPerson : t.legalEntity, y, helveticaFont, helveticaBold);
    
    if (owner.type === 'PHYSIQUE') {
      y = drawLabelValue(page, `${t.fullName}:`, formatValue(owner.fullName || `${owner.firstName || ''} ${owner.lastName || ''}`, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.firstName}:`, formatValue(owner.firstName, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.lastName}:`, formatValue(owner.lastName, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.gender}:`, formatValue(owner.gender, language), y, helveticaFont, helveticaBold);
    } else {
      y = drawLabelValue(page, `${t.companyName}:`, formatValue(owner.organizationName, language), y, helveticaFont, helveticaBold);
    }
    
    y = drawLabelValue(page, `${t.phone}:`, formatValue(owner.phone, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.email}:`, formatValue(owner.email, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(owner.cinNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(owner.taxpayerNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.syndicate}:`, formatValue(owner.ownerSyndicate, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(owner.categoryLicenseNumber || vehicleAdmin.ownerCatLicenseNumber, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.licenseDate}:`, formatValue(owner.categoryLicenseIssueDate || vehicleAdmin.ownerCatLicenseIssueDate, language), y, helveticaFont, helveticaBold);
    y = drawLabelValue(page, `${t.taxisOperated}:`, formatValue(owner.taxisOperated || vehicleAdmin.taxisOperated, language), y, helveticaFont, helveticaBold);
    
    let procurationStatus = t.no;
    if (owner.hasProcuration) procurationStatus = t.yes;
    else if (owner.skipProcuration) procurationStatus = t.skipped;
    
    y = drawLabelValue(page, `${t.hasProcuration}:`, procurationStatus, y, helveticaFont, helveticaBold);
    
    y -= 10;
    
    // Check if we need a new page
    if (y < 100) {
      page = pdfDoc.addPage([612, 792]);
      y = 750;
    }
    
    // ========== DRIVER INFORMATION ==========
    y = drawSectionHeader(page, t.driversInfo, y, helveticaBold);
    
    const drivers = verification?.drivers || [];
    const driverObj = verification?.driver || {};
    const driverDocuments = verification?.driverDocuments || {};
    
    // If this is driver workflow (single driver)
    if (verification?.actorRole === 'DRIVER' && driverObj.personId) {
      page.drawText(`${t.mainDriver}:`, {
        x: 50,
        y: y + 5,
        size: 12,
        font: helveticaBold,
        color: rgb(0.85, 0.57, 0.47), // COLORS.secondary
      });
      
      y -= 15;
      
      y = drawLabelValue(page, `${t.personId}:`, formatValue(driverObj.personId, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.fullName}:`, formatValue(driverObj.fullName || `${driverObj.firstName || ''} ${driverObj.lastName || ''}`, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.phone}:`, formatValue(driverObj.phone, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.email}:`, formatValue(driverObj.email, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.birthDate}:`, formatValue(driverObj.birthDate, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.gender}:`, formatValue(driverObj.gender, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(driverObj.cinNumber, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(driverObj.taxpayerNumber, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(driverObj.licenseNumber, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.licenseCategory}:`, formatValue(driverObj.licenseCategory, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.syndicate}:`, formatValue(driverObj.driverSyndicate, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.capacityNumber}:`, formatValue(driverObj.capacityNumber, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.hasCapacityDoc}:`, driverObj.hasCapacityDoc ? t.yes : t.no, y, helveticaFont, helveticaBold);
      
      let secureBadgeStatus = t.notSpecified;
      if (driverObj.secureBadge === true) secureBadgeStatus = t.yes;
      else if (driverObj.secureBadge === false) secureBadgeStatus = t.no;
      
      y = drawLabelValue(page, `${t.hasSecureBadge}:`, secureBadgeStatus, y, helveticaFont, helveticaBold);
      
      // Documents for this driver
      const docs = driverDocuments[driverObj.personId] || {};
      y = drawLabelValue(page, `${t.documents}:`, '', y, helveticaFont, helveticaBold);
      y -= 15;
      
    //   page.drawText(`  ${t.photo}: ${docs.photo ? t.symbolProvided : t.symbolMissing}`, {
    //     x: 70,
    //     y,
    //     size: 10,
    //     font: helveticaFont,
    //     color: rgb(0.04, 0.1, 0.12),
    //   });
    //   y -= 15;
      
      page.drawText(`  ${t.licenseNumber}: ${docs.license ? t.symbolProvided : t.symbolMissing}`, {
        x: 70,
        y,
        size: 10,
        font: helveticaFont,
        color: rgb(0.04, 0.1, 0.12),
      });
      y -= 15;
      
      page.drawText(`  ${t.cinNumber}: ${docs.idCard ? t.symbolProvided : t.symbolMissing}`, {
        x: 70,
        y,
        size: 10,
        font: helveticaFont,
        color: rgb(0.04, 0.1, 0.12),
      });
      y -= 15;
      
      page.drawText(`  ${t.capacityNumber}: ${docs.capacity ? t.symbolProvided : t.symbolMissing}`, {
        x: 70,
        y,
        size: 10,
        font: helveticaFont,
        color: rgb(0.04, 0.1, 0.12),
      });
      y -= 15;
      
    } 
    // If this is owner workflow (multiple drivers)
    else if (drivers.length > 0) {
      drivers.forEach((driver, index) => {
        // Check if we need a new page
        if (y < 150) {
          page = pdfDoc.addPage([612, 792]);
          y = 750;
        }
        
        page.drawText(`${t.driver} ${index + 1}:`, {
          x: 50,
          y: y + 5,
          size: 12,
          font: helveticaBold,
          color: rgb(0.85, 0.57, 0.47),
        });
        
        y -= 15;
        
        y = drawLabelValue(page, `${t.personId}:`, formatValue(driver.personId, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.fullName}:`, formatValue(driver.name, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.phone}:`, formatValue(driver.phone, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.email}:`, formatValue(driver.email, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.birthDate}:`, formatValue(driver.birthDate, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.gender}:`, formatValue(driver.gender, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.cinNumber}:`, formatValue(driver.cinNumber, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.taxpayerNumber}:`, formatValue(driver.taxpayerNumber, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(driver.licenseNumber, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.licenseCategory}:`, formatValue(driver.licenseCategory, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.syndicate}:`, formatValue(driver.driverSyndicate, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.capacityNumber}:`, formatValue(driver.capacityNumber, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.hasCapacityDoc}:`, driver.hasCapacityDoc ? t.yes : t.no, y, helveticaFont, helveticaBold);
        
        let secureBadgeStatus = t.notSpecified;
        if (driver.secureBadge === true) secureBadgeStatus = t.yes;
        else if (driver.secureBadge === false) secureBadgeStatus = t.no;
        
        y = drawLabelValue(page, `${t.hasSecureBadge}:`, secureBadgeStatus, y, helveticaFont, helveticaBold);
        
        // Document status
        y = drawLabelValue(page, `${t.documents}:`, '', y, helveticaFont, helveticaBold);
        y -= 15;
        
        // page.drawText(`  ${t.photo}: ${driver.hasDriverPhoto ? t.symbolProvided : t.symbolMissing}`, {
        //   x: 70,
        //   y,
        //   size: 10,
        //   font: helveticaFont,
        //   color: rgb(0.04, 0.1, 0.12),
        // });
        // y -= 15;
        
        page.drawText(`  ${t.licenseNumber}: ${driver.hasDriverLicense ? t.symbolProvided : t.symbolMissing}`, {
          x: 70,
          y,
          size: 10,
          font: helveticaFont,
          color: rgb(0.04, 0.1, 0.12),
        });
        y -= 15;
        
        page.drawText(`  ${t.cinNumber}: ${driver.hasDriverIdCard ? t.symbolProvided : t.symbolMissing}`, {
          x: 70,
          y,
          size: 10,
          font: helveticaFont,
          color: rgb(0.04, 0.1, 0.12),
        });
        y -= 15;
        
        page.drawText(`  ${t.capacityNumber}: ${driver.hasDriverCapacity ? t.symbolProvided : t.symbolMissing}`, {
          x: 70,
          y,
          size: 10,
          font: helveticaFont,
          color: rgb(0.04, 0.1, 0.12),
        });
        y -= 20;
      });
    } else {
      page.drawText(t.notSpecified, {
        x: 50,
        y: y - 5,
        size: 10,
        font: helveticaFont,
        color: rgb(0.42, 0.45, 0.5),
      });
      y -= 20;
    }
    
    y -= 10;
    
    // Check if we need a new page
    if (y < 150) {
      page = pdfDoc.addPage([612, 792]);
      y = 750;
    }
    
    // ========== DOCUMENT STATUS ==========
    y = drawSectionHeader(page, t.documentStatus, y, helveticaBold);
    
    if (documentStatus) {
      // Provided documents
      if (documentStatus.provided && documentStatus.provided.length > 0) {
        page.drawText(`${t.provided}:`, {
          x: 50,
          y: y + 5,
          size: 11,
          font: helveticaBold,
          color: rgb(0.09, 0.63, 0.52), // COLORS.teal
        });
        y -= 15;
        
        documentStatus.provided.forEach(doc => {
          page.drawText(`  ${t.symbolProvided} ${doc.label}: ${doc.message || `${doc.fileCount} ${t.filesCount}`}`, {
            x: 50,
            y,
            size: 10,
            font: helveticaFont,
            color: rgb(0.04, 0.1, 0.12),
          });
          y -= 15;
        });
      }
      
      // Skipped documents
      if (documentStatus.skipped && documentStatus.skipped.length > 0) {
        page.drawText(`${t.skipped}:`, {
          x: 50,
          y: y + 5,
          size: 11,
          font: helveticaBold,
          color: rgb(0.96, 0.65, 0.14), // COLORS.warning
        });
        y -= 15;
        
        documentStatus.skipped.forEach(doc => {
          page.drawText(`  ${t.symbolSkipped} ${doc.label}: ${doc.message || t.skipped}`, {
            x: 50,
            y,
            size: 10,
            font: helveticaFont,
            color: rgb(0.04, 0.1, 0.12),
          });
          y -= 15;
        });
      }
      
      // Missing documents
      if (documentStatus.missing && documentStatus.missing.length > 0) {
        page.drawText(`${t.missing}:`, {
          x: 50,
          y: y + 5,
          size: 11,
          font: helveticaBold,
          color: rgb(0.86, 0.15, 0.15), // COLORS.error
        });
        y -= 15;
        
        documentStatus.missing.forEach(doc => {
          page.drawText(`  ${t.symbolMissing} ${doc.label}: ${doc.message || t.missing}`, {
            x: 50,
            y,
            size: 10,
            font: helveticaFont,
            color: rgb(0.04, 0.1, 0.12),
          });
          y -= 15;
        });
      }
    }
    
    y -= 10;
    
    // ========== QR CODES ==========
    y = drawSectionHeader(page, t.qrCodes, y, helveticaBold);
    
    const vehicleQrStatus = data.vehicleQrGenerated ? `${t.symbolProvided} ${t.generated}` : `${t.symbolMissing} ${t.notGenerated}`;
    y = drawLabelValue(page, `${t.vehicleQr}:`, vehicleQrStatus, y, helveticaFont, helveticaBold);
    
    const driverQrStatus = `${data.driverQrsGenerated || 0} ${t.generated.toLowerCase()}`;
    y = drawLabelValue(page, `${t.driverQrs}:`, driverQrStatus, y, helveticaFont, helveticaBold);
    
    y -= 10;
    
    // ========== MATCHED DRIVER ==========
    if (verification?.matchedDriverData) {
      // Check if we need a new page
      if (y < 100) {
        page = pdfDoc.addPage([612, 792]);
        y = 750;
      }
      
      y = drawSectionHeader(page, t.matchedDriver, y, helveticaBold);
      y = drawLabelValue(page, `${t.fullName}:`, formatValue(verification.matchedDriverData.name, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.phone}:`, formatValue(verification.matchedDriverData.phone, language), y, helveticaFont, helveticaBold);
      y = drawLabelValue(page, `${t.licenseNumber}:`, formatValue(verification.matchedDriverData.license_number, language), y, helveticaFont, helveticaBold);
      y -= 10;
    }
    
    // ========== PAYMENT INFO ==========
    if (verification?.isPaymentMade) {
      // Check if we need a new page
      if (y < 100) {
        page = pdfDoc.addPage([612, 792]);
        y = 750;
      }
      
      y = drawSectionHeader(page, t.paymentInfo, y, helveticaBold);
      y = drawLabelValue(page, `${t.paymentMade}:`, t.yes, y, helveticaFont, helveticaBold);
      
      if (verification.paymentInfo) {
        y = drawLabelValue(page, `${t.generatedOn}:`, formatDate(verification.paymentInfo.date, language), y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.amount}:`, `${verification.paymentInfo.amount || '500'} FCFA`, y, helveticaFont, helveticaBold);
        y = drawLabelValue(page, `${t.reference}:`, formatValue(verification.paymentInfo.reference, language), y, helveticaFont, helveticaBold);
      }
      
      y -= 10;
    }
    
    // ========== FOOTER ==========
    // Ensure footer is on its own page if needed
    if (y < 80) {
      page = pdfDoc.addPage([612, 792]);
      y = 750;
    }
    
    // Draw footer line
    page.drawLine({
      start: { x: 50, y: y - 10 },
      end: { x: 550, y: y - 10 },
      thickness: 1,
      color: rgb(0.9, 0.9, 0.9),
    });
    
    y -= 25;
    
    page.drawText(t.footer, {
      x: 50,
      y,
      size: 9,
      font: helveticaFont,
      color: rgb(0.42, 0.45, 0.5),
    });
    
    y -= 15;
    
    page.drawText(t.support, {
      x: 50,
      y,
      size: 9,
      font: helveticaFont,
      color: rgb(0.42, 0.45, 0.5),
    });
    
    // Save the PDF
    const pdfBytes = await pdfDoc.save();
    
    if (Platform.OS === 'web') {
      // Web: Create blob and download
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `recapitulatif_verification_${verification?.verificationId || Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return { success: true };
    } else {
      // Native: Save to file system and share
      const fileName = `recapitulatif_verification_${verification?.verificationId || Date.now()}.pdf`;
      const filePath = `${FileSystem.cacheDirectory}${fileName}`;
      
      // Convert array buffer to base64
      const base64 = Buffer.from(pdfBytes).toString('base64');
      
      await FileSystem.writeAsStringAsync(filePath, base64, {
        encoding: FileSystem.EncodingType.Base64,
      });
      
      if (await Sharing.isAvailableAsync()) {
        await Sharing.shareAsync(filePath);
      }
      
      return { success: true, filePath };
    }
  } catch (error) {
    console.error('Error generating PDF: - pdfGenerator.js:1832', error);
    return { success: false, error };
  }
};

export default generateSummaryPDF;